import { render, staticRenderFns } from "./JciEventTypeList.vue?vue&type=template&id=3fc45812"
import script from "./JciEventTypeList.vue?vue&type=script&lang=js"
export * from "./JciEventTypeList.vue?vue&type=script&lang=js"
import style0 from "./JciEventTypeList.vue?vue&type=style&index=0&id=3fc45812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports